import React, { useState } from "react";
import { FormattedMessage } from "react-intl";

import { Chevron } from "./Icons";

type CollabsibleSectionProps = {
  title: string;
  state?: boolean;
  children: React.ReactNode;
  id?: string;
};

const CollabsibleSection = ({
  title,
  state = false,
  children,
  id,
}: CollabsibleSectionProps) => {
  const [collapse, setCollapse] = useState(state);

  return (
    <>
      <div
        className="profile-modal__collapsible"
        role="button"
        id={id}
        onClick={() => setCollapse(() => !collapse)}
      >
        {!collapse ? (
          <div className="profile-modal__chevron">
            <Chevron />
          </div>
        ) : (
          <div className="profile-modal__chevron chevron--right">
            <Chevron />
          </div>
        )}
        <span className="profile-modal__collapsible-title">
          <FormattedMessage id={title} />
        </span>
      </div>
      {collapse && children}
    </>
  );
};

export default CollabsibleSection;
